export default __webpack_public_path__ + "static/media/ic-sort.ce00527f.svg";